import { generateUUID } from "@osu/react-ui";
import RadioInputGroup from "./Group";

export const validateRadioInputChoices = (choices = []) => {
  if (!Array.isArray(choices) || !choices?.length) {
    return [];
  }
  return choices.filter((c) => c?.label && Object.hasOwn(c, "value"));
};

function RadioInput(props = {}) {
  const {
    id: _id,
    helperText,
    required = false,
    error = undefined,
    // inputProps,
    // modal,
    // variant = "outlined",
    name,
    choices = [],
    label,
    description,
    onChange,
    value,
    setValue,
    readOnly 
    // ...rest
  } = props;
  const id = _id || name || generateUUID("fg-radio");
  const validChoices = validateRadioInputChoices(choices).map(
    (choice = {}, idx) => {
      const choiceId =
        choice?.id || id + "-" + (choice?.value || "empty") + idx;
      const relatedQuestionsId = choice?.relatedQuestions?.length
        ? choiceId + "-relatedQuestions"
        : undefined;
      return {
        ...choice,
        id: choiceId,
        relatedQuestionsId: relatedQuestionsId,
      };
    }
  );
  if (!validChoices?.length) {
    return false;
  }

  const radioGroupProps = {
    id,
    label,
    required,
    error,
    description,
    choices: validChoices,
    helperText,
    name,
    onChange,
    value,
    setValue,
    readOnly
  };

  return <RadioInputGroup {...radioGroupProps} />;
}

export default RadioInput